import Modal from "../Modal/Modal";
import RadioGroup from "../RadioGroup/RadioGroup";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { MdClose } from "react-icons/md";
import useMobile from "src/hooks/useMobile";
import useLanguages from "src/hooks/useLanguages";
import SettingsPerDeviceInfoBlock from "../InfoBlock/SettingsPerDeviceInfoBlock/SettingsPerDeviceInfoBlock";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface ILanguageChangeModal {
  onClose: () => void;
}

const LanguageChangeModal: React.FC<ILanguageChangeModal> = ({ onClose }) => {
  const { t } = useTranslation(["modals", "common"]);
  const {
    currentLanguageId,
    changeLanguage,
    allLanguagesSelect,
    isChangingLanguage,
  } = useLanguages();
  const { isMobile } = useMobile();

  return (
    <Modal onEscape={onClose} className="md:!w-[500px]">
      <Modal.Header
        onClose={onClose}
        title={t("modals:language_change.title")}
      />
      <Modal.Body>
        <div className={clsx(["flex", "w-full", "gap-4", "flex-col"])}>
          <SettingsPerDeviceInfoBlock />
          <div className={clsx(["flex", "flex-col", "gap-2"])}>
            <div className={clsx(["flex", "w-full", "md:text-sm", "text-xs"])}>
              {t("modals:language_change.description")}
            </div>
            <RadioGroup
              columns={isMobile ? 2 : 2}
              onChange={(lang: any) => {
                changeLanguage(lang);
              }}
              selected={currentLanguageId}
              options={allLanguagesSelect}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: onClose,
            disabled: isChangingLanguage,
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
            isLoading: isChangingLanguage,
          },
        ]}
      />
    </Modal>
  );
};

export default LanguageChangeModal;
